//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "AgrMonitoringSoil",
  data() {
    return {
      deviceTypeId: "",
      btnActive: 1,
      timeVal: "",
      real: {},
      realAll_Temp: {
        //土壤温度
        flat: [],
        vert: [],
      },
      realAll_Humidity: {
        //土壤湿度
        flat: [],
        vert: [],
      },
      realAll_Conductivity: {
        //电导率
        flat: [],
        vert: [],
      },
      realAll_Salinity: {
        //土壤盐分
        flat: [],
        vert: [],
      },
      realAll_Ph: {
        //土壤ph值
        flat: [],
        vert: [],
      },
      realData: {
        deviceCode: "-",
        deviceName: "-",
      },
      soilV4temData: "",
      soilV4humData: "",
      soilV4SaltData: "",
      soilV4ConData: "",
      edition: "",
      responseTime: "",
    };
  },
  mounted() {},
  created() {
    this.getRealSoilDate();
    this.getRealSoilDateAll();
  },
  methods: {
    // 土壤实时数据
    getRealSoilDate() {
      let farmAllData = JSON.parse(sessionStorage.getItem("farmAllData"));
      this.edition = farmAllData.edition;
      this.realData = {
        deviceCode: farmAllData.deviceCode,
        deviceName: farmAllData.deviceName,
      };
      let obj = { sensorNum: this.realData.deviceCode };
      if (this.edition != 4) {
        this.$http.agrModel.getRealSoil(obj).then((res) => {
          console.log(res);
          if (res.status === "1") {
            this.real = res.data;
          } else {
            this.$message({
              message: res.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        });
      } else {
        this.$http.nqMonitor
          .monitorGroupV4({ imei: farmAllData.deviceCode })
          .then((res) => {
            if (res.status == 1) {
              this.responseTime = res.data.result[0].sendTime;
              if (res.data.result && res.data.result.length > 0) {
                let soilV4DataList = res.data.result;
                var that = this;
                soilV4DataList.forEach((val) => {
                  // B1土壤温度
                  if (val.sensorType && val.sensorType == "B1") {
                    that.soilV4temData = val.sensorData;
                  }
                  // B2土壤湿度
                  if (val.sensorType && val.sensorType == "B2") {
                    that.soilV4humData = val.sensorData;
                  }
                  // B3土壤盐分
                  if (val.sensorType && val.sensorType == "B3") {
                    that.soilV4SaltData = val.sensorData;
                  }
                  // B4土壤电导率
                  if (val.sensorType && val.sensorType == "B4") {
                    that.soilV4ConData = val.sensorData;
                  }
                });
                this.deviceStatus = "设备正常";
              } else {
                this.soilV4temData = "";
                this.soilV4humData = "";
                this.soilV4SaltData = "";
                this.soilV4ConData = "";
                this.deviceStatus = null;
              }
            } else {
              this.deviceStatus = null;
            }
          });
      }
    },
    // 土壤历史数据
    getRealSoilDateAll(data) {
      let time = "";
      let timeArr = [];
      let currentDay = false;
      if (this.btnActive === 1) {
        time = "w";
      } else if (this.btnActive === 2) {
        time = "m";
      } else {
        timeArr = data;
        if (this.timeVal && this.timeVal[0] != "" && this.timeVal[1] != "") {
          if (this.timeVal[0] == this.timeVal[1]) {
            currentDay = true;
          }
        }
      }
      let obj = {
        sensorNum: this.realData.deviceCode,
        type: time,
        startTime: timeArr[0],
        endTime: timeArr[1],
      }; //类型；w 最近七天；m 最近30天
      if (this.edition != 4) {
        this.$http.agrModel.getRealSoilAll(obj).then((res) => {
          console.log(res);
          if (res.status === "1") {
            this.realAll_Temp.flat = res.data.Temp.flat;
            this.realAll_Temp.vert = res.data.Temp.vert;
            this.realAll_Humidity.vert = res.data.Humidity.vert;
            this.realAll_Humidity.flat = res.data.Humidity.flat;
            this.realAll_Conductivity.vert = res.data.Conductivity.vert;
            this.realAll_Conductivity.flat = res.data.Conductivity.flat;
            this.realAll_Salinity.vert = res.data.Salinity.vert;
            this.realAll_Salinity.flat = res.data.Salinity.flat;
            this.realAll_Ph.vert = res.data.Ph.vert;
            this.realAll_Ph.flat = res.data.Ph.flat;
            this.getEchartData1();
            this.getEchartData2();
            this.getEchartData3();
            this.getEchartData4();
            this.getEchartData5();
          } else {
            this.$message({
              message: res.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        });
      } else {
        this.$http.nqMonitor.monitorHisGroupV4(obj).then((res) => {
          console.log(res);
          if (res.data.code == 1) {
            let echartsDatas = res.data.result;
            if (echartsDatas.length > 0) {
              var that = this;
              echartsDatas.forEach((item) => {
                if (item.sensorType && item.sensorType == "B1") {
                  let soilSaltMapList = item.list;
                  if (soilSaltMapList.length > 0) {
                    that.realAll_Temp.flat = [];
                    that.realAll_Temp.vert = [];
                    soilSaltMapList.forEach((its) => {
                      that.realAll_Temp.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_Temp.vert.push(its.sensorData);
                      } else {
                        that.realAll_Temp.vert.push(its.avgVal);
                      }
                    });
                  }
                }
                if (item.sensorType && item.sensorType == "B2") {
                  let soilConductivityDataMapList = item.list;
                  if (soilConductivityDataMapList.length > 0) {
                    that.realAll_Humidity.flat = [];
                    that.realAll_Humidity.vert = [];
                    soilConductivityDataMapList.forEach((its) => {
                      that.realAll_Humidity.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_Humidity.vert.push(its.sensorData);
                      } else {
                        that.realAll_Humidity.vert.push(its.avgVal);
                      }
                    });
                  }
                }
                if (item.sensorType && item.sensorType == "B3") {
                  let soilSaltMapList = item.list;
                  if (soilSaltMapList.length > 0) {
                    that.realAll_Salinity.flat = [];
                    that.realAll_Salinity.vert = [];
                    soilSaltMapList.forEach((its) => {
                      that.realAll_Salinity.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_Salinity.vert.push(its.sensorData);
                      } else {
                        that.realAll_Salinity.vert.push(its.avgVal);
                      }
                    });
                  }
                }
                if (item.sensorType && item.sensorType == "B4") {
                  let soilConductivityDataMapList = item.list;
                  if (soilConductivityDataMapList.length > 0) {
                    that.realAll_Conductivity.flat = [];
                    that.realAll_Conductivity.vert = [];
                    soilConductivityDataMapList.forEach((its) => {
                      that.realAll_Conductivity.flat.push(its.sendTime);
                      if (currentDay == true) {
                        that.realAll_Conductivity.vert.push(its.sensorData);
                      } else {
                        that.realAll_Conductivity.vert.push(its.avgVal);
                      }
                    });
                  }
                }
              });
            } else {
              this.realAll_Temp.flat = [];
              this.realAll_Temp.vert = [];
              this.realAll_Humidity.flat = [];
              this.realAll_Humidity.vert = [];
              this.realAll_Conductivity.flat = [];
              this.realAll_Conductivity.vert = [];
              this.realAll_Salinity.flat = [];
              this.realAll_Salinity.vert = [];
            }
            this.getEchartData1();
            this.getEchartData2();
            this.getEchartData3();
            this.getEchartData4();
            this.getEchartData5();
          } else {
            this.$message({
              message: res.errMsg,
              type: "error",
              customClass: "customClass",
            });
          }
        });
      }
    },
    // getEchartData函数都为 图表
    getEchartData1() {
      const chart1 = document.getElementById("chart1");
      var _that = this;
      if (chart1) {
        const myChart = this.$echarts.init(chart1);
        const option = {
          tooltip: {
            trigger: "axis",

            formatter: (params) => {
              let template = "";
              params.forEach((item, index) => {
                if (index == 0) {
                  template = item.axisValue + "<br>";
                }
                if (item.seriesType === "line") {
                  item.value += "";
                }
                template =
                  template +
                  item.marker +
                  "土壤温度（℃）" +
                  " : " +
                  item.value +
                  "<br>";
              });
              return template;
            },
            areaStyle: {
              itemStyle: {
                normal: {
                  color: "#3FE1E7",
                  lineStyle: {
                    color: "#3FE1E7",
                  },
                },
              },
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#cff7f9", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cff7f9", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
          grid: {
            left: "3%",
            right: "6%",
            bottom: "14%",
            top: "6%",
            containLabel: true,
          },

          xAxis: {
            type: "category",
            boundaryGap: false,
            data: _that.realAll_Temp.flat,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              type: "line",
              stack: "Total",
              areaStyle: {},
              itemStyle: {
                normal: {
                  color: "#cff7f9",
                  lineStyle: {
                    color: "#3FE1E7",
                  },
                },
              },
              data: _that.realAll_Temp.vert,
            },
          ],
          legend: {
            left: "center",
            bottom: 0,
          },
        };
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    getEchartData2() {
      const chart2 = document.getElementById("chart2");
      if (chart2) {
        const myChart = this.$echarts.init(chart2);
        const option = {
          tooltip: {
            trigger: "axis",
            formatter: (params) => {
              let template = "";
              params.forEach((item, index) => {
                if (index == 0) {
                  template = item.axisValue + "<br>";
                }
                if (item.seriesType === "line") {
                  item.value += "";
                }
                template =
                  template +
                  item.marker +
                  "土壤湿度（%RH）" +
                  " : " +
                  item.value +
                  "<br>";
              });
              return template;
            },
          },
          areaStyle: {
            itemStyle: {
              normal: {
                color: "#3FE1E7",
                lineStyle: {
                  color: "#3FE1E7",
                },
              },
            },
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "#cff7f9", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#cff7f9", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
          grid: {
            left: "3%",
            right: "6%",
            bottom: "14%",
            top: "6%",
            containLabel: true,
          },

          xAxis: {
            type: "category",
            boundaryGap: false,

            data: this.realAll_Humidity.flat,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              type: "line",
              stack: "Total",
              areaStyle: {},
              itemStyle: {
                normal: {
                  color: "#cff7f9",
                  lineStyle: {
                    color: "#3FE1E7",
                  },
                },
              },
              data: this.realAll_Humidity.vert,
            },
          ],
          legend: {
            left: "center",
            bottom: 0,
          },
        };
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    getEchartData3() {
      const chart3 = document.getElementById("chart3");
      if (chart3) {
        const myChart = this.$echarts.init(chart3);
        const option = {
          tooltip: {
            trigger: "axis",
            formatter: (params) => {
              let template = "";
              params.forEach((item, index) => {
                if (index == 0) {
                  template = item.axisValue + "<br>";
                }
                if (item.seriesType === "line") {
                  item.value += "";
                }
                template =
                  template +
                  item.marker +
                  "电导率（μS/cm）" +
                  " : " +
                  item.value +
                  "<br>";
              });
              return template;
            },
          },
          areaStyle: {
            itemStyle: {
              normal: {
                color: "#3FE1E7",
                lineStyle: {
                  color: "#3FE1E7",
                },
              },
            },
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "#cff7f9", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#cff7f9", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
          grid: {
            left: "3%",
            right: "6%",
            bottom: "14%",
            top: "6%",
            containLabel: true,
          },

          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.realAll_Conductivity.flat,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              type: "line",
              stack: "Total",
              areaStyle: {},
              itemStyle: {
                normal: {
                  color: "#cff7f9",
                  lineStyle: {
                    color: "#3FE1E7",
                  },
                },
              },
              data: this.realAll_Conductivity.vert,
            },
          ],
          legend: {
            left: "center",
            bottom: 0,
          },
        };
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    getEchartData4() {
      const chart4 = document.getElementById("chart4");
      if (chart4) {
        const myChart = this.$echarts.init(chart4);
        const option = {
          tooltip: {
            trigger: "axis",
            formatter: (params) => {
              let template = "";
              params.forEach((item, index) => {
                if (index == 0) {
                  template = item.axisValue + "<br>";
                }
                if (item.seriesType === "line") {
                  item.value += "";
                }
                template =
                  template +
                  item.marker +
                  "土壤盐分（μS/cm）" +
                  " : " +
                  item.value +
                  "<br>";
              });
              return template;
            },
          },
          areaStyle: {
            itemStyle: {
              normal: {
                color: "#3FE1E7",
                lineStyle: {
                  color: "#3FE1E7",
                },
              },
            },
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "#cff7f9", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#cff7f9", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
          grid: {
            left: "3%",
            right: "6%",
            bottom: "14%",
            top: "6%",
            containLabel: true,
          },

          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.realAll_Salinity.flat,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              type: "line",
              stack: "Total",
              areaStyle: {},
              itemStyle: {
                normal: {
                  color: "#cff7f9",
                  lineStyle: {
                    color: "#3FE1E7",
                  },
                },
              },
              data: this.realAll_Salinity.vert,
            },
          ],
          legend: {
            left: "center",
            bottom: 0,
          },
        };
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    getEchartData5() {
      const chart5 = document.getElementById("chart5");
      if (chart5) {
        const myChart = this.$echarts.init(chart5);
        const option = {
          tooltip: {
            trigger: "axis",
            formatter: (params) => {
              let template = "";
              params.forEach((item, index) => {
                if (index == 0) {
                  template = item.axisValue + "<br>";
                }
                if (item.seriesType === "line") {
                  item.value += "";
                }
                template =
                  template +
                  item.marker +
                  "土壤PH值" +
                  " : " +
                  item.value +
                  "<br>";
              });
              return template;
            },
          },
          areaStyle: {
            itemStyle: {
              normal: {
                color: "#3FE1E7",
                lineStyle: {
                  color: "#3FE1E7",
                },
              },
            },
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "#cff7f9", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#cff7f9", // 100% 处的颜色
                },
              ],
              global: false, // 缺省为 false
            },
          },
          grid: {
            left: "3%",
            right: "6%",
            bottom: "14%",
            top: "6%",
            containLabel: true,
          },

          xAxis: {
            type: "category",
            boundaryGap: false,
            data: this.realAll_Ph.flat,
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              type: "line",
              stack: "Total",
              areaStyle: {},
              itemStyle: {
                normal: {
                  color: "#cff7f9",
                  lineStyle: {
                    color: "#3FE1E7",
                  },
                },
              },
              data: this.realAll_Ph.vert,
            },
          ],
          legend: {
            left: "center",
            bottom: 0,
          },
        };
        myChart.setOption(option);
        window.addEventListener("resize", function () {
          myChart.resize();
        });
      }
      this.$on("hook:destroyed", () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      });
    },
    timeClick(num) {
      this.timeVal = "";
      this.btnActive = num;
      if (num === 1) {
        this.getRealSoilDateAll("w");
      } else if (num === 2) {
        this.getRealSoilDateAll("m");
      }
      {
      }
    },
    dateChange(val) {
      if (val && val[0]) {
        this.btnActive = 3;
      }
      this.getRealSoilDateAll(val);
    },
  },
  components: {},
};
